export default __webpack_public_path__ + "9a3d661f35e453300afb33c729a7f936.png";